
import Vue from 'vue';
import { LogIt } from '@/plugins/webApi';
export default Vue.extend({
    name: 'Login',
    data: () => ({
        username: '',
        show: false,
        auth: false,
        isError: false,
        errorMsg: '',
        password: '',
    }),
    // watch: {
    //     show(n: boolean, o: boolean): void {
    //         this.auth = n;
    //     },
    // },
    methods: {
        hasError(): void {
            if (this.$route.params.error) {
                this.errorMsg = atob(this.$route.params.error);
                this.isError = true;
                LogIt(`(Login.vue)->hasError() ${this.errorMsg}`, true);
            } else {
                this.isError = false;
                this.auth = false;
                this.show = false;
            }
        },
        async register(): Promise<void> {
            // try {
            //     const response = await fetch(`/register/${encodeURIComponent(this.username)}`);
                
            //     if (!response.ok) {
            //         const msg = await response.json();
            //         throw new Error(msg.error);
            //     }

            //     const options = await response.json();
            //     console.log(options)

            //     // This triggers the browser to display the passkey / WebAuthn modal (e.g. Face ID, Touch ID, Windows Hello).
            //     // A new attestation is created. This also means a new public-private-key pair is created.
            //     const attestationResponse = await SimpleWebAuthnBrowser.startRegistration(options.publicKey);

            //     // Send attestationResponse back to server for verification and storage.
            //     const verificationResponse = await fetch(`/register/${encodeURIComponent(this.username)}`, {
            //         method: 'POST',
            //         headers: {
            //             'Content-Type': 'application/json',
            //             'Session-Key': response.headers.get('Session-Key')
            //         },
            //         body: JSON.stringify(attestationResponse)
            //     });


            //     const msg = await verificationResponse.json();
            //     // if (verificationResponse.ok) {
            //     //     showMessage(msg, false);
            //     // } else {
            //     //     showMessage(msg, true);
            //     // }
            // } catch (error) {
            //     console.error(error);
            // }
        },
        async signIn(): Promise<void> {
            // const secCon = new SecurityController('csanchez', null);
            // let hash = sha256.create();
            // hash.update(new Date().getMilliseconds().toString());
            // hash.update("SuPER");
            // hash.update(new Date().getUTCDay().toString());
            // secCon.set(hash.hex());
            // Retrieve the username from the input field
            // try {
            //     // Get login options from your server. Here, we also receive the challenge.
            //     const response = await fetch(`/login/${encodeURIComponent(this.username)}`);
            //     // Check if the login options are ok.
            //     if (!response.ok) {
            //         const msg = await response.json();
            //         throw new Error(msg.error);
            //     }
            //     // Convert the login options to JSON.
            //     const options = await response.json();

            //     // This triggers the browser to display the passkey / WebAuthn modal (e.g. Face ID, Touch ID, Windows Hello).
            //     // A new assertionResponse is created. This also means that the challenge has been signed.
            //     const assertionResponse = await SimpleWebAuthnBrowser.startAuthentication(options.publicKey);

            //     // Send assertionResponse back to server for verification.
            //     const verificationResponse = await fetch(`/login/${encodeURIComponent(this.username)}`, {
            //         method: 'POST',
            //         headers: {
            //             'Content-Type': 'application/json',
            //             'Session-Key': response.headers.get('Session-Key'),
            //         },
            //         body: JSON.stringify(assertionResponse)
            //     });

            //     const msg = await verificationResponse.json();
            //     // if (verificationResponse.ok) {
            //     //     showMessage(msg, false);
            //     // } else {
            //     //     showMessage(msg, true);
            //     // }
            // } catch (error) {
            //     console.error(error); 
            // }
        }
    },
    updated() {
        this.hasError();
    },
    mounted() {
        this.hasError();
    },
});
